import { IUserBase } from '../../models/users';
import wbsBookingsApi from '../apis/wbsBookingsApi';

const resetUsersOnboardingService = async (
  userId: string,
): Promise<IUserBase> => {
  const { data } = await wbsBookingsApi.post<IUserBase>(
    `/users/${userId}/reset-onboarding`,
  );

  return data;
};

export default resetUsersOnboardingService;
